import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=372c1235&scoped=true"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=372c1235&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c1235",
  null
  
)

export default component.exports